<template>
    <div class="postback">
        <VHeader page="Postbacks"></VHeader>
        <div class="postback-wrapper">
            <div class="postback-wrapper_title postback-wrapper_text">
                Url*
            </div>
            <VInput
                :class="{'postback-wrapper_error' : isUrlEmpty}"
                v-model="newPostback.url"
                placeholder='Url*'
            ></VInput>
            <div class="postback-wrapper_traffic postback-wrapper_traffic__description">
                the macros {clickid} is
                mandatory ; the {payout} is
                optional
            </div>
        </div>
        <div class="postback-wrapper">
            <div class="postback-wrapper_title postback-wrapper_text">
                Source*
            </div>
            <VInput
                :class="{'postback-wrapper_error' : isSourceEmpty}"
                v-model="newPostback.source"
                placeholder='Source*'
            ></VInput>
        </div>
        <div class="postback-wrapper">
            <div class="postback-wrapper_title postback-wrapper_text">
                Bundle id*
            </div>
            <VSelect
                :item="newPostback.project"
                :class="{'postback-wrapper_error' : isBundleIdEmpty}"
                :options="projects"
                :show-property="'bundle_id'"
                @updateItem="changeProject"
            >
                <VButton>{{ newPostback.project.bundle_id || 'Choose bundle id' }}</VButton>
            </VSelect>
        </div>
        <div class="postback-wrapper">
            <div class="postback-wrapper_title">
                Event
            </div>
            <VSelect
                :item="newPostback.event"
                :options="events"
                :show-property="'title'"
                @updateItem="changeEvent"
            >
                <VButton>{{ newPostback.event.title }}</VButton>
            </VSelect>
        
        </div>
        <div class="postback-wrapper">
            <div class="postback-wrapper_title">
                Campaign
            </div>
            <VInput
                v-model="newPostback.filter.equal.campaign"
                placeholder='Campaign'
                :disabled="isCampaingDisabled"
            ></VInput>
            <div class="postback-wrapper_traffic postback-wrapper_traffic__description">
                Use space for multiple values
            </div>
        </div>
        <div class="postback-wrapper postback-wrapper__button">
            <VButton
                @click=" addPostback"
                :type="'button'"
                theme="positive"
            >Add postback
            </VButton>
        </div>
        <div class="postback-table highlighted-table">
            <template v-if="!isLoading">
                <div class="postback-table-header">
                    <div class="postback-table-header-title">
                        Url
                    </div>
                    <div class="postback-table-header-title ">
                        Source
                    </div>
                    <div class="postback-table-header-title">
                        Event
                    </div>
                    <div class="postback-table-header-title">
                        Bundle id
                    </div>
                    <div class="postback-table-header-title">
                        Campaign
                    </div>
                    <div class="postback-table-header-title postback-table-header-title__long">
                    
                    </div>
                </div>
                <div
                    class="postback-table-row "
                    v-for="(postback, postbackIndex) in postbacks"
                    :key="postback.name"
                >
                    <div class="postback-table-row-text">
                        {{ postback.url }}
                    </div>
                    <div class="postback-table-row-text ">
                        {{ postback.source }}
                    </div>
                    <div
                        class="postback-table-row-text "
                    >
                        {{ postback.event }}
                    </div>
                    <div
                        class="postback-table-row-text "
                    >
                        {{ postback.bundle_id }}
                    </div>
                    <div
                        class="postback-table-row-text "
                    >
                        <template v-if="postback.filter.equal && postback.filter.equal.campaign">
                            {{ postback.filter.equal.campaign.join(', ') }}
                        </template>
                    </div>
                    <div
                        class=" postback-table-row-close-icon"
                        @click="deletePostback(postbackIndex)"
                    >
                    </div>
                </div>
            </template>
            <template v-else>
                <VLoadingRow
                    height="60px"
                ></VLoadingRow>
            </template>
        </div>
    
    
    </div>
</template>
<script>
    import VButton from '../components/VButton';
    import apiPostbacks from '../api/apiPostbacks';
    import VSelect from '../components/VSelect';
    import {getEvents} from '../api/apiServices';
    import apiApps from '../api/apiApps';
    import VLoadingRow from '../components/VLoadingRow';
    
    export default {
        name: 'Postback',
        components: {
            VButton,
            VSelect,
            VLoadingRow,
        },
        data() {
            return {
                selected: null,
                isUrlEmpty: false,
                isBundleIdEmpty: false,
                isSourceEmpty: false,
                isLoading: true,
                newPostback: {},
                emptyPostback: Object.freeze({
                    url: '',
                    source: '',
                    event: {
                        title: 'payout event',
                    },
                    project: {},
                    filter: {
                        equal: {
                            campaign: '',
                        },
                    },
                }),
                events: [],
                projects: [],
                postbacks: [],
            };
        },
        created() {
            this.newPostback = _.cloneDeep(this.emptyPostback);
            
            apiApps.getApps().then((response) => {
                this.projects = _.cloneDeep(response.data);
            }).catch((error) => {
                this.$toastr.e(error.response.data.error);
            });
            
            apiPostbacks.getPostbacks().then((res) => {
                this.isLoading = false;
                this.postbacks = res.data;
            }).catch(() => {
                this.$toastr.longError('Api error');
            });
            
            let events = getEvents().map(function (name) {
                return {title: name};
            });
            events.unshift({title: 'payout event'});
            this.events = Object.freeze(events);
        },
        computed: {
            isCampaingDisabled() {
                return this.newPostback.event.title.toLowerCase() === 'payout event';
            },
        },
        methods: {
            addPostback() {
                this.isUrlEmpty = false;
                this.isBundleIdEmpty = false;
                this.isSourceEmpty = false;
                if (!this.newPostback.url) {
                    this.$toastr.longError('Url can\'t be empty');
                    this.isUrlEmpty = true;
                }
                if (!this.newPostback.source) {
                    this.$toastr.longError('Source can\'t be empty');
                    this.isSourceEmpty = true;
                }
                if (!this.newPostback.project.bundle_id) {
                    this.$toastr.longError('Bundle id can\'t be empty');
                    this.isBundleIdEmpty = true;
                }
                if (this.newPostback.url && this.newPostback.project.bundle_id && this.newPostback.source) {
                    const sendPostback = _.cloneDeep(this.newPostback);
                    if (sendPostback.filter.equal.campaign) {
                        sendPostback.filter.equal.campaign = sendPostback.filter.equal.campaign.split(' ');
                    } else {
                        delete sendPostback.filter.equal.campaign;
                    }
                    if (sendPostback.event.title.toLowerCase().trim() === 'subscription') {
                        sendPostback.filter.equal.subscription_type = ['new'];
                    }
                    
                    if (!sendPostback.filter.equal.campaign && !sendPostback.filter.equal.subscription_type) {
                        delete sendPostback.filter;
                    }
                    sendPostback.event = sendPostback.event.title.toLowerCase() === 'payout event' ? '' : sendPostback.event.title;
                    sendPostback.bundle_id = sendPostback.project.bundle_id;
                    delete sendPostback.project;
                    apiPostbacks.addPostback(sendPostback).then((res) => {
                        const tablePostback = _.cloneDeep(sendPostback);
                        tablePostback.id = res.data.id;
                        tablePostback.filter = tablePostback.filter ? tablePostback.filter : {
                            equal: {
                                campaign: [],
                            },
                        };
                        this.postbacks.push(tablePostback);
                        this.$toastr.s('Added');
                    }).catch(() => {
                        this.$toastr.longError('Api error');
                    });
                    this.newPostback = _.cloneDeep(this.emptyPostback);
                }
            },
            deletePostback(postbackIndex) {
                apiPostbacks.deletePostback(this.postbacks[postbackIndex].id).then(() => {
                    this.$toastr.s('Deleted');
                    this.postbacks.splice(postbackIndex, 1);
                }).catch(() => {
                    this.$toastr.longError('Api error');
                });
            },
            changeEvent(event) {
                this.newPostback.event = {title: event.title};
                if (this.newPostback.event.title.toLowerCase() === 'payout event') {
                    this.newPostback.filter.equal.campaign = '';
                }
            },
            changeProject(project) {
                this.newPostback.project = project;
            },
        },
    };
</script>


<style
    lang="scss"
    scoped
>
    .postback {
        &-wrapper {
            display: flex;
            width: 535px;
            margin-left: 10px;
            margin-top: 5px;
            
            //background-color: #00cd96;
            &_title {
                display: flex;
                min-width: 100px;
                align-items: center;
                padding-top: 5px;
            }
            
            &_text {
                color: red;
            }
            
        }
        
        //::v-deep {
        //    .VSelect-dropdown {
        //        width: 220px;
        //        right: 0px;
        //    }
        //}
        
        .postback-wrapper_error {
            ::v-deep {
                input {
                    border-color: red;
                }
            }
            
            
            ::v-deep {
                .VButton {
                    border-color: red;
                }
            }
        }
        
        &-wrapper_traffic {
            margin-right: -264px;
            align-self: center;
            
        }
        
        &-wrapper_traffic__description {
            margin-left: 15px;
        }
        
        
        &-wrapper__button {
            display: flex;
            
            margin-top: 15px;
            margin-left: 126px;
            
        }
        
        &-table {
            border-radius: 10px;
            @include dark-shadow;
            max-width: 927px;
            margin: 26px;
            
            &-header {
                display: flex;
                height: 45px;
                border-bottom: 1px solid #6089E7;
                @media (max-width: 927px) {
                    padding-left: 5px;
                    padding-right: 20%;
                }
                
                &-title {
                    text-align: center;
                    margin-top: 23px;
                    font-family: Poppins;
                    height: 12px;
                    color: #000F48;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 12px;
                    width: 180px;
                    
                }
                
                &-title__long {
                    width: 27px;
                }
            }
            
            &-row {
                display: flex;
                align-items: center;
                min-height: 45px;
                //padding-right: 46px;
                //@include dark-shadow;
                border-top: 1px solid rgba(96, 137, 231, 0.2);
                @media (max-width: 927px) {
                    padding-left: 5px;
                    padding-right: 2%;
                }
                
                &-text {
                    font-family: Quicksand;
                    word-break: break-word;
                    padding: 10px;
                    color: #000F48;
                    font-size: 14px;
                    letter-spacing: 0;
                    width: 180px;
                    text-align: center;
                    @media (max-width: 927px) {
                        font-size: 12px;
                    }
                }
                
                &-close-icon {
                    display: flex;
                    float: right;
                    width: 17px;
                    height: 17px;
                    padding-right: 10px;
                    //background-position: 0 0;
                    background-repeat: no-repeat;
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE3cHgiIGhlaWdodD0iMTdweCIgdmlld0JveD0iMCAwIDE3IDE3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT41QzJERjVGNi01QzAwLTRFQjctQTBBMS0wQUJEMDc4NDdERTFAMSw1eDwvdGl0bGU+DQogICAgPGcgaWQ9IlBhZ2UtNCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIzLjAwMDAwMCwgLTQ0NC4wMDAwMDApIiBmaWxsPSIjMDJERkIwIiBzdHJva2U9IiM2MDg5RTciPg0KICAgICAgICAgICAgPGcgaWQ9Imljb24vY2xvc2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0LjAwMDAwMCwgNDQ1LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjcwNzEwNjc4LDAuMjkyODkzMjE5IEw3LjQ1OSw2LjA0NSBMMTMuMTA1ODgwOCwwLjM5OTIyNTA2NiBDMTMuNTAyMjc3NiwwLjAwMjgyODIyODEyIDE0LjE0NDk2MzksMC4wMDI4MjgyMjgxMiAxNC41NDEzNjA3LDAuMzk5MjI1MDY2IEMxNC45Mzc3NTc1LDAuNzk1NjIxOTAzIDE0LjkzNzc1NzUsMS40MzgzMDgxNiAxNC41NDEzNjA3LDEuODM0NzA1IEw4Ljg5NSw3LjQ4IEwxNC42NDc2OTI1LDEzLjIzMzQ3OSBDMTUuMDM4MjE2OCwxMy42MjQwMDMzIDE1LjAzODIxNjgsMTQuMjU3MTY4MiAxNC42NDc2OTI1LDE0LjY0NzY5MjUgQzE0LjI1NzE2ODIsMTUuMDM4MjE2OCAxMy42MjQwMDMzLDE1LjAzODIxNjggMTMuMjMzNDc5LDE0LjY0NzY5MjUgTDcuNDgsOC44OTUgTDEuODM0NzA1LDE0LjU0MTM2MDcgQzEuNDM4MzA4MTYsMTQuOTM3NzU3NSAwLjc5NTYyMTkwMywxNC45Mzc3NTc1IDAuMzk5MjI1MDY2LDE0LjU0MTM2MDcgQzAuMDAyODI4MjI4MTIsMTQuMTQ0OTYzOSAwLjAwMjgyODIyODEyLDEzLjUwMjI3NzYgMC4zOTkyMjUwNjYsMTMuMTA1ODgwOCBMNi4wNDUsNy40NTkgTDAuMjkyODkzMjE5LDEuNzA3MTA2NzggQy0wLjA5NzYzMTA3MjksMS4zMTY1ODI0OSAtMC4wOTc2MzEwNzI5LDAuNjgzNDE3NTExIDAuMjkyODkzMjE5LDAuMjkyODkzMjE5IEMwLjY4MzQxNzUxMSwtMC4wOTc2MzEwNzI5IDEuMzE2NTgyNDksLTAuMDk3NjMxMDcyOSAxLjcwNzEwNjc4LDAuMjkyODkzMjE5IFoiPjwvcGF0aD4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==');
                    cursor: pointer;
                }
            }
        }
        
        .VInput {
            width: 185px;
            
            ::v-deep {
                input {
                    width: calc(100% - 14px);
                }
                
            }
        }
        
        .VSelect {
            cursor: pointer;
            width: 185px;
            
            &-title {
                width: 100%;
            }
            
            ::v-deep {
                .VButton {
                    width: 100%;
                    
                    &__title {
                        width: 133px;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        text-align: left;
                        
                    }
                }
            }
            
        }
    }
</style>